// extracted by mini-css-extract-plugin
export var modal = "_uw-0";
export var table = "_uw-1";